type SalonBadge = 'SALON';

type SalonBadgeSource = {
  isSalonMember?: boolean;
  isSalonPremiumMember?: boolean;
};

const SALON_BADGE_LABEL = 'SALON';

function getSalonBadge({
  isSalonMember,
  isSalonPremiumMember,
}: SalonBadgeSource): SalonBadge | undefined {
  if (isSalonMember || isSalonPremiumMember) return 'SALON';
  return undefined;
}

export type { SalonBadge, SalonBadgeSource };
export { getSalonBadge, SALON_BADGE_LABEL };
